// extracted by mini-css-extract-plugin
export var tosLink = "_bh-0";